import { type FC, type SyntheticEvent } from 'react';

import { CardNarrowMenuItem } from '@/microfrontends/listing/shared/components/CardNarrowMenuItem';
import { useHideOffer } from '@/microfrontends/listing/shared/hooks/card/useHideOffer';

import { HideIcon } from '@/packages/shared-ui/components/HideIcon';

export const MenuItemHideOfferContainer: FC = () => {
  const hideOffer = useHideOffer();

  return (
    <CardNarrowMenuItem
      icon={<HideIcon />}
      title="Скрыть"
      onClick={(e: SyntheticEvent) => {
        e.stopPropagation();
        hideOffer();
      }}
    />
  );
};
